import { z } from 'zod';
import { command, get, put } from '../http';
import { resource } from '../schemas/common';
import { packageSchema } from '../schemas/domain';

export const packageInput = z.object({
  name: z.string().min(2),
  amount_usd: z.coerce.number().positive(),
  description: z.string().optional(),
  is_active: z.boolean(),
});
export type PackageInput = z.infer<typeof packageInput>;

export const packagesApi = {
  list: () => get('/packages', resource(z.array(packageSchema))),
  show: (id: string) => get(`/packages/${id}`, resource(packageSchema)),

  /* admin */
  adminList: () => get('/admin/packages', resource(z.array(packageSchema))),
  update: (id: string, input: PackageInput) =>
    put(`/admin/packages/${id}`, resource(packageSchema), input),
  toggle: (id: string) => command(`/admin/packages/${id}/toggle`),
};
